import { useState } from "react";
import { initialsOf } from "./format.js";

/**
 * A person, as small as it needs to be. Falls back to initials when there is no
 * picture, and also when the picture fails to load — Google's avatar URLs stop
 * resolving often enough that a broken image icon would be a regular sight.
 */
export const Avatar = ({ user, size = 28, color, title }) => {
  const [broken, setBroken] = useState(false);
  const name = user?.name ?? user?.email ?? "?";
  const ring = color ? { boxShadow: `0 0 0 2px ${color}`, borderColor: "transparent" } : undefined;

  if (user?.picture && !broken) {
    return (
      <img
        className="avatar"
        src={user.picture}
        alt=""
        title={title ?? name}
        width={size}
        height={size}
        style={{ width: size, height: size, ...ring }}
        referrerPolicy="no-referrer"
        onError={() => setBroken(true)}
      />
    );
  }

  return (
    <span
      className="avatar"
      title={title ?? name}
      style={{
        width: size,
        height: size,
        fontSize: Math.round(size * 0.38),
        ...(color ? { background: color, color: "#1a1714", ...ring } : {}),
      }}
    >
      {initialsOf(name)}
    </span>
  );
};
